export var GoogleWorkspaceGroupRestoreScope;
(function (GoogleWorkspaceGroupRestoreScope) {
    GoogleWorkspaceGroupRestoreScope["GOOGLE_WORKSPACE_GROUP_RESTORE_SCOPE_UNSPECIFIED"] = "GOOGLE_WORKSPACE_GROUP_RESTORE_SCOPE_UNSPECIFIED";
    GoogleWorkspaceGroupRestoreScope["GOOGLE_WORKSPACE_GROUP_RESTORE_SCOPE_GROUP_ONLY"] = "GOOGLE_WORKSPACE_GROUP_RESTORE_SCOPE_GROUP_ONLY";
    GoogleWorkspaceGroupRestoreScope["GOOGLE_WORKSPACE_GROUP_RESTORE_SCOPE_GROUP_AND_MESSAGES"] = "GOOGLE_WORKSPACE_GROUP_RESTORE_SCOPE_GROUP_AND_MESSAGES";
})(GoogleWorkspaceGroupRestoreScope || (GoogleWorkspaceGroupRestoreScope = {}));
